<style lang="scss">
    .el-table__fixed {
        height: 438px;
    }
    .my-table-block {
        height: 500px;
    }
</style>
<template>
    <my-table style="height:100%" ref="table" :cols="collectCols" :data="list" :loading="loading" :page-param="page" single hide-multiple
              @init="init" @refresh="getList" @pageChange="pageChange" @paramChange="paramChange" :height="height"
              @cndClusterChange="cndClusterChange" @handleRowDbClickChange="handleDb">
    </my-table>
</template>

<script>
    // import axios from '@/util/api'
    // import help from '@/util/help'
    import tableMixin from '@/util/tableMixin'

    export default {
        mixins: [tableMixin],
        props: {
            collectApi:{

            },
            collectCols: {
                type: Array,
                default: () => {
                    return []
                }
            },
            headId: {
                type: String,
            },
        },
        data() {
            return {
                height: 500,
                api: {
                    list: '',   // 列表接口
                },
                cols: [],
                query: {
                    headId : '',
                },
                queryFunc: () => {},
            }
        },
        created() {
            this.api.list = this.collectApi.list;
            this.cols = this.collectCols.map(item => {
                item.viewList = true
                return item
            })
            if (this.headId) {
                this.query.headId = this.headId
            }

            // if (this.obj.query) {
            //     this.queryFunc = this.obj.query
            // }

        },
        methods: {
            handleDb(data) {
                this.$emit('change', data)
            }
        }
    }
</script>
